{
  "manager": {
    "userList": {
      "addUser": "Add User",
      "memberId": "Member ID",
      "userAddedSuccess": "User added successfully",
      "userAddFailed": "Failed to add user",
      "userRemovedSuccess": "User removed successfully",
      "userRemoveFailed": "Failed to remove user",
      "userLoadFailed": "Failed to load users"
    },
    "boundaryCreateContainer": {
      "editInstructions": "To edit a boundary click \"Reset Boundary\" then create your updated boundary by clicking around the area on the map. Then click \"Save\" and exit.",
      "title": "Title",
      "titlePlaceholder": "Enter a title for your boundary",
      "drawBoundary": "Draw Boundary"
    },
    "boundaryMap": {
      "resetBoundary": "Reset Boundary"
    },
    "organizationFiles": {
      "files": "Files",
      "upload": "Upload"
    },
    "simpleOrganizationSearch": {
      "searchPlaceholder": "Search by email or name",
      "changeSelection": "Change Selection"
    },
    "organizationIndex": {
      "title": "Organizations"
    }
  }
}
